import { render, staticRenderFns } from "./PublisherContacts.vue?vue&type=template&id=4e426810&scoped=true&lang=pug"
import script from "./PublisherContacts.vue?vue&type=script&lang=js"
export * from "./PublisherContacts.vue?vue&type=script&lang=js"
import style0 from "./PublisherContacts.vue?vue&type=style&index=0&id=4e426810&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e426810",
  null
  
)

export default component.exports